import React, {useEffect, useState} from "react";
import dairemCepteLogo from '../images/dairemcepte-logo.svg';
import segaCennet from '../images/segacennet3.jpg';
import segaIstanbul from '../images/segaist8.jpg';
import segaPlus from '../images/segaplus-2.jpg';
import begonyaPark from '../images/begonyapark.jpg';
import esinApartman from '../images/esinapartman.jpg';
import truvaGol from '../images/truvagolevleri.jpg';
import segaMarin from '../images/segaMarin.png';
import bathonea from '../images/bathonea.png';
import segaCadde from '../images/segaCadde.png';

const Slider = () => {
	const images = [segaCadde, segaCennet, segaIstanbul, segaPlus, begonyaPark, esinApartman, truvaGol, segaMarin, bathonea];
	const [currentIndex, setCurrentIndex] = useState(0);
	const [prevIndex, setPrevIndex] = useState(images.length - 1);

	useEffect(() => {
		const interval = setInterval(() => {
			setPrevIndex(currentIndex);
			setCurrentIndex((prev) => (prev + 1) % images.length);
		}, 6000);

		return () => clearInterval(interval);
	}, [currentIndex, images.length]);

	return (
		<section className='slider'>
			{images.map((image, index) => (
				<img
					key={index}
					src={image}
					alt=''
					aria-hidden='true'
					className={`slider-img ${
						index === currentIndex ? 'slide-in' : index === prevIndex ? 'slide-out' : ''
					}`}
				/>
			))}
			<div className='slider-text'>
				<span className='section-eyebrow' style={{color: '#fff', opacity: 0.85}}>
					Proteam Yönetim
				</span>
				<h1>Apartmanınız ve sitenizin profesyonel yönetimi.</h1>
				<h4>BÜTÇE · TEKNİK · GÜVENLİK · TEMİZLİK · HUKUK</h4>
				<div className='hero-actions'>
					<a className='btn btn-outline' href='tel:05078098989'>
						<i className='fa fa-phone' aria-hidden='true'></i>
						Bilgi Al
					</a>
					<a
						className='btn btn-cta'
						href='https://dairemcepte.com'
						target='_blank'
						rel='noopener noreferrer'
					>
						<img src={dairemCepteLogo} alt='DairemCepte' className='modal-button-logo'/>
						DairemCepte Site Sakin Girişi
					</a>
				</div>
			</div>
		</section>
	);
};

export default Slider;
